module.exports = __webpack_public_path__ + "static/media/gd.5df5e43f.png";